import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { isStatusValid } from '../../validator-consultaSeguimento'
import { ConsultaSeguimentoPergunta02Model } from './model-consultaSeguimentoPergunta02'

export const validatorConsultaSeguimentoPergunta02 = createValidator<ConsultaSeguimentoPergunta02Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_02_IGNORA: createValidator<ConsultaSeguimentoPergunta02Model['PERGUNTA_02_IGNORA']>({
      IGNORA_PESSOAS: required,
      IGNORA_SONS: required,
    }),
    PERGUNTA_02_FEZ_EXAME: required,
  },
  (values: ConsultaSeguimentoPergunta02Model, errors: ErrorObject<ConsultaSeguimentoPergunta02Model>) => {
    if (values?.PERGUNTA_02_FEZ_EXAME === SimNaoEnum.SIM) {
      errors.PERGUNTA_02_RESULTADO_EXAME = required(values.PERGUNTA_02_RESULTADO_EXAME)
    }
    return errors
  }
)
